import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const AddCopyPlanSn = ({ planObj, planYearList, control, errors }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const placeNameField = (placeNames) => {
    // 確保 placeNames 永遠是陣列
    const namesArray = Array.isArray(placeNames) ? placeNames : [placeNames];

    if (!namesArray || namesArray.length === 0) return null;

    const showCount = 1; // 超過 1 個收合
    const displayList = expanded ? namesArray : namesArray.slice(0, showCount);
    const remaining = namesArray.length - showCount;

    const displayValue = displayList.join(", ");

    return (
      <span className="inline-flex items-center gap-1">
        <span>{displayValue}</span>
        {remaining > 0 && (
          <Button
            type="button"
            onClick={() => setExpanded(!expanded)}
            className="p-button-text"
            icon={expanded ? "pi pi-angle-up" : "pi pi-angle-down"}
            text
            size="small"
            style={{ height: "1.5rem", width: "0.2rem" }}
          />
        )}
      </span>
    );
  };

  return (
    <div className="grid">
      <div className="col-12 lg:col-6">
        <label className="form-label font-bold">{t("queryYear")}</label>
        <span>{planObj?.displayYear}</span>
      </div>
      <div className="col-12 lg:col-6">
        <label className="form-label font-bold">{t("place_name")}</label>
        <span>{placeNameField(planObj?.placeName)}</span>
      </div>
      <div className="col-12">
        <label className="form-label font-bold my-1">{t("copyTo")}</label>
      </div>
      <div className="col-12">
        <label htmlFor="year" className="form-label font-bold required">
          {" "}
          {t("queryYear")}
        </label>
        <Controller
          name="year"
          control={control}
          render={({ field, fieldState }) => (
            <Dropdown
              optionLabel="subitemName"
              optionValue="subitemNo"
              value={field.value}
              virtualScrollerOptions={{ itemSize: 40 }}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name="year"
              control={control}
              options={planYearList}
              className={`w-full ${classNames({ "p-invalid": fieldState.error })}`}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
      </div>
      <div className="col-12">
        <Controller
          name="dataFlag"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <Checkbox
                inputId={field.name}
                checked={field.value}
                inputRef={field.ref}
                className={classNames({ "p-invalid": fieldState.error })}
                onChange={(e) => field.onChange(e.checked)}
              />
              <label htmlFor={field.name} className="ml-2">
                {t("includeActivityData")}
              </label>
            </>
          )}
        />
      </div>
    </div>
  );
};

export default AddCopyPlanSn;
